<template>
  <div class="flex items-center justify-between rounded-t">
    <Heading level="2">
      <slot />
    </Heading>
    <button
      v-if="onClose"
      class="modal-close-button"
      :title="t('close')"
      type="button"
      @click="onClose">
      <IconBase
        height="22"
        viewBox="0 0 16 16"
        width="22">
        <Times />
      </IconBase>
    </button>
  </div>
</template>

<script setup lang="ts">
import {Heading, IconBase, Times} from '@myparcel-frontend/ui';
import {useI18n} from 'vue-i18n';

defineProps<{
  onClose?: () => void;
}>();

const {t} = useI18n();
</script>

<style lang="scss" scoped>
@reference "../../../assets/css/index.css";

.modal-close-button {
  @apply text-black bg-transparent rounded-lg text-sm ml-auto inline-flex items-center;
}
</style>
